import { IntRange } from "./IntRange.type";

/* Data model (selectable options) */

type Time = { hour: IntRange<0, 24>; minute: 0 | 30; display: string }; // What do we need on this?

export interface TimeOfDayOption {
  start: Time;
  end: Time;
  display: string;
}

export const timeOfDayOptions: TimeOfDayOption[] = Array(48)
  .fill(0)
  .map(
    (_, index): Time => {
      const hour = Math.floor(index / 2) as Time["hour"];
      const minute = index % 2 === 0 ? 0 : 30;

      const hh = `0${hour}`.slice(-2);
      const mm = `0${minute}`.slice(-2);

      return {
        hour,
        minute,
        display: `${hh}:${mm}`,
      };
    }
  )
  .reduce((timeOfDayOptions, time, index, times): TimeOfDayOption[] => {
    const start = time;
    const end = times[(index + 1) % times.length];

    const option = {
      start,
      end,
      display: `${start.display} – ${end.display}`,
    };

    return timeOfDayOptions.concat(option);
  }, [] as TimeOfDayOption[]);
